import React, { Component } from "react";
import Popup from "reactjs-popup";
import GoogleLoginButton from "./GoogleLoginButton";
import {CircularProgress} from "@material-ui/core";

class LoginPopUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggingIn: false
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoggingIn !== this.props.isLoggingIn) {
            this.setState({ isLoggingIn:this.props.isLoggingIn });
        }
    }

    render() {
        return (
            <Popup
                open={ true }
                closeOnDocumentClick={ false }
                borderRadius={10}
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center',
                    marginTop: 30, marginBottom: 30 }}>
                    <div>Please Login in order to use Triton Plan Pro</div>
                    <div style={{ width: 181, height: 44, marginTop: 35 }}>
                        {
                            this.state.isLoggingIn
                                ? <CircularProgress size={30} />
                                : <GoogleLoginButton onGoogleLogin={ this.props.onGoogleLogin } />
                        }
                    </div>
                </div>
            </Popup>
        );
    }
}

export default LoginPopUp;